import { lazyLoad } from 'utils/loadable';

/**
 *
 * Asynchronously loads the component for SignUpPage
 *
 */

const SignUpPage = lazyLoad(
  () => import('app/modules/Auth/SignUp/SignUp'),
  (module) => module.default,
);

export default SignUpPage;
